import styled from 'styled-components';

export const Container = styled.div`
  margin: 1rem 0 0 0;
`;

